import { type ResultOf, type VariablesOf, graphql } from 'gql.tada';
import CitySuburbsFragment from '@discover-data/gql/fragments/citySuburbs';

const GetCitySuburbsQuery = graphql(
  `
    query GetCitySuburbs($id: Int!) {
      City(id: $id) {
        id
        suburbs {
          edges {
            node {
              ...CitySuburbsFragment
            }
          }
        }
      }
    }
  `,
  [CitySuburbsFragment]
);

export type QueryVariables = VariablesOf<typeof GetCitySuburbsQuery>;
export type QueryResult = ResultOf<typeof GetCitySuburbsQuery>;

export default GetCitySuburbsQuery;
